export const CLIENTS_LIST = "CLIENTS_LIST";
export const CLIENTS_LIST_FAILED = "CLIENTS_LIST_FAILED";
export const CLIENTS_LIST_SUCCESS = "CLIENTS_LIST_SUCCESS";
